/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCompetitionCashProfitStandingsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetCompetitionCashProfitStandingsArgs, useGetCompetitionCashProfitStandingsSpec, useGetCompetitionCashProfitStandingsRealtime, useGetCompetitionCashProfitStandingsPagination } from '../specs/competitions.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetCompetitionCashProfitStandingsRow } from '../openapi-types.gen.js';
export type { useGetCompetitionCashProfitStandingsArgs } from '../specs/competitions.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetCompetitionCashProfitStandingsPaginationContract = useGetCompetitionCashProfitStandingsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetCompetitionCashProfitStandingsInfinite` — both
 * read/write the same `PagedData<GetCompetitionCashProfitStandingsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): competitionId, limit, cursor.
 */
const _useGetCompetitionCashProfitStandings = createListHook({
  spec: useGetCompetitionCashProfitStandingsSpec,
  realtime: useGetCompetitionCashProfitStandingsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionCashProfitStandingsPaginationContract,
});
export const useGetCompetitionCashProfitStandings = _useGetCompetitionCashProfitStandings as (args: useGetCompetitionCashProfitStandingsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionCashProfitStandings>;


/**
 * Auto-infinite: same cache as `useGetCompetitionCashProfitStandings`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetCompetitionCashProfitStandings` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetCompetitionCashProfitStandingsInfinite = createListHook({
  spec: useGetCompetitionCashProfitStandingsSpec,
  realtime: useGetCompetitionCashProfitStandingsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionCashProfitStandingsPaginationContract,
  autoLoadMore: true,
});
export const useGetCompetitionCashProfitStandingsInfinite = _useGetCompetitionCashProfitStandingsInfinite as (args: useGetCompetitionCashProfitStandingsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionCashProfitStandingsInfinite>;


/**
 * Per-field subscription hook for the `useGetCompetitionCashProfitStandings` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetCompetitionCashProfitStandingsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetCompetitionCashProfitStandingsField = createFieldHook<GetCompetitionCashProfitStandingsRow>('useGetCompetitionCashProfitStandingsField');

/**
 * Hover/intent prefetch companion for `useGetCompetitionCashProfitStandings` (also covers
 * `useGetCompetitionCashProfitStandingsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetCompetitionCashProfitStandings();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetCompetitionCashProfitStandings = createPrefetchHook(useGetCompetitionCashProfitStandingsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCompetitionCashProfitStandingsArgs>;
